import { render, staticRenderFns } from "./QrcodeGen.vue?vue&type=template&id=80a4d72a&scoped=true"
import script from "./QrcodeGen.vue?vue&type=script&lang=js"
export * from "./QrcodeGen.vue?vue&type=script&lang=js"
import style0 from "./QrcodeGen.vue?vue&type=style&index=0&id=80a4d72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a4d72a",
  null
  
)

export default component.exports